module.exports = __webpack_public_path__ + "img/raw4.d305d372.png";